import { SHCheckbox } from "@components/design-systems";
import { AnalysisSummaryDTO } from "@models/platform-analysis/entities/steps/summary";
import { memo } from "react";
import { Controller, FieldPath, useFormContext } from "react-hook-form";

export type SummaryCommentSettingCheckboxProps = {
  fieldPath: FieldPath<AnalysisSummaryDTO>;
  isDisabled?: boolean;
};

export const SummaryCommentSettingCheckbox = memo(
  ({
    fieldPath,
    isDisabled = false,
  }: SummaryCommentSettingCheckboxProps) => {
    const { control } = useFormContext<AnalysisSummaryDTO>();

    return (
      <Controller
        name={fieldPath}
        control={control}
        render={({ field }) => (
          <SHCheckbox
            disabled={isDisabled}
            checked={field.value}
            onChange={field.onChange}
          ></SHCheckbox>
        )}
      />
    );
  },
);
